import { render, staticRenderFns } from "./OpenInNewTabIcon.vue?vue&type=template&id=796e7b90"
import script from "./OpenInNewTabIcon.vue?vue&type=script&lang=js"
export * from "./OpenInNewTabIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports